import axios from "axios";

const host = window && window.location && window.location.host;

let API_URL = "";
let BASE_URL = "";  // ← add

console.log("Current host:", host);  // Debugging line to check the host value

if (host.includes("localhost") || host.includes("127.0.0.1")) {
  API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
  BASE_URL = API_URL.replace("/api", "");   // → http://localhost:8000
} else if (host.includes("testapp.cedurnow.com") || host.includes("testapp")){
  API_URL = "https://test.cedurnow.com/api";
  BASE_URL = "https://test.cedurnow.com";
} else{
  API_URL = "https://cedurnow.com/api";
  BASE_URL = "https://cedurnow.com";
}

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: false, // Set to true if using cookies
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem("auth_token");

      // Redirect to login page if not already there
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    // Handle 403 Forbidden errors
    if (error.response?.status === 403) {
      console.error("Access forbidden:", error.response.data.message);
    }

    // Handle 500 Server errors
    if (error.response?.status === 500) {
      console.error("Server error:", error.response.data);
    }

    return Promise.reject(error);
  },
);
export { BASE_URL }; 
export default api;
